// Tipos de documento soportados
export const DOCUMENT_TYPES = {
  DNI_ES: 'dni_es',
  NIE_ES: 'nie_es',
  PASSPORT: 'passport',
  ID_CARD_EU: 'id_card_eu',
  RESIDENCE_PERMIT: 'residence_permit'
}

// Configuración por tipo de documento
export const DOCUMENT_CONFIG = {
  [DOCUMENT_TYPES.DNI_ES]: {
    label: 'DNI Español',
    icon: '🇪🇸',
    description: 'Documento Nacional de Identidad',
    format: /^[0-9]{8}[A-Z]$/,
    maxLength: 9,
    placeholder: '12345678Z',
    helpText: 'Introduce tu DNI con letra (ej: 12345678Z)',
    requiresBack: false,
    validator: 'validateDNI'
  },
  [DOCUMENT_TYPES.NIE_ES]: {
    label: 'NIE Español',
    icon: '🇪🇸',
    description: 'Número de Identidad de Extranjero',
    format: /^[XYZ][0-9]{7}[A-Z]$/,
    maxLength: 9,
    placeholder: 'X1234567L',
    helpText: 'Introduce tu NIE completo (ej: X1234567L)',
    requiresBack: false,
    validator: 'validateNIE'
  },
  [DOCUMENT_TYPES.PASSPORT]: {
    label: 'Pasaporte',
    icon: '🛂',
    description: 'Pasaporte internacional',
    format: /^[A-Z0-9]{6,12}$/,
    maxLength: 12,
    placeholder: 'AA123456',
    helpText: 'Introduce el número de tu pasaporte (6-12 caracteres)',
    requiresBack: false,
    validator: 'validatePassport'
  },
  [DOCUMENT_TYPES.ID_CARD_EU]: {
    label: 'Tarjeta ID UE',
    icon: '🇪🇺',
    description: 'Tarjeta de identidad europea',
    format: /^[A-Z0-9]{6,15}$/,
    maxLength: 15,
    placeholder: 'Depende del país',
    helpText: 'Introduce el número de tu tarjeta de identidad',
    requiresBack: false,
    validator: 'validateIDCardEU'
  },
  [DOCUMENT_TYPES.RESIDENCE_PERMIT]: {
    label: 'Permiso de Residencia',
    icon: '🏠',
    description: 'Tarjeta de residencia',
    format: /^[A-Z0-9]{6,15}$/,
    maxLength: 15,
    placeholder: 'Varía según el país',
    helpText: 'Introduce el número de tu permiso de residencia',
    requiresBack: false,
    validator: 'validateResidencePermit'
  }
}

// Configuración de documentos disponibles por país
export const COUNTRY_DOCUMENTS = {
  ES: [],  // España no tiene selector - auto-detecta DNI/NIE
  FR: [DOCUMENT_TYPES.ID_CARD_EU, DOCUMENT_TYPES.PASSPORT],
  DE: [DOCUMENT_TYPES.ID_CARD_EU, DOCUMENT_TYPES.PASSPORT],
  IT: [DOCUMENT_TYPES.ID_CARD_EU, DOCUMENT_TYPES.PASSPORT],
  PT: [DOCUMENT_TYPES.ID_CARD_EU, DOCUMENT_TYPES.PASSPORT],
  UK: [DOCUMENT_TYPES.PASSPORT, DOCUMENT_TYPES.RESIDENCE_PERMIT],
  US: [DOCUMENT_TYPES.PASSPORT],
  MX: [DOCUMENT_TYPES.PASSPORT, DOCUMENT_TYPES.RESIDENCE_PERMIT],
  BR: [DOCUMENT_TYPES.PASSPORT, DOCUMENT_TYPES.RESIDENCE_PERMIT],
  AR: [DOCUMENT_TYPES.PASSPORT, DOCUMENT_TYPES.RESIDENCE_PERMIT],
  CN: [DOCUMENT_TYPES.PASSPORT],
  JP: [DOCUMENT_TYPES.PASSPORT],
  IN: [DOCUMENT_TYPES.PASSPORT],
  OTHER: [DOCUMENT_TYPES.PASSPORT]
}

// Lista de países con banderas
export const COUNTRIES = [
  { code: 'ES', name: 'España', flag: '🇪🇸', region: 'Europa' },
  { code: 'FR', name: 'Francia', flag: '🇫🇷', region: 'Europa' },
  { code: 'DE', name: 'Alemania', flag: '🇩🇪', region: 'Europa' },
  { code: 'IT', name: 'Italia', flag: '🇮🇹', region: 'Europa' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', region: 'Europa' },
  { code: 'UK', name: 'Reino Unido', flag: '🇬🇧', region: 'Europa' },
  { code: 'NL', name: 'Países Bajos', flag: '🇳🇱', region: 'Europa' },
  { code: 'BE', name: 'Bélgica', flag: '🇧🇪', region: 'Europa' },
  { code: 'US', name: 'Estados Unidos', flag: '🇺🇸', region: 'América' },
  { code: 'MX', name: 'México', flag: '🇲🇽', region: 'América' },
  { code: 'BR', name: 'Brasil', flag: '🇧🇷', region: 'América' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', region: 'América' },
  { code: 'CN', name: 'China', flag: '🇨🇳', region: 'Asia' },
  { code: 'JP', name: 'Japón', flag: '🇯🇵', region: 'Asia' },
  { code: 'IN', name: 'India', flag: '🇮🇳', region: 'Asia' },
  { code: 'OTHER', name: 'Otro país', flag: '🌍', region: 'Otros' }
]

/**
 * Validar pasaporte internacional
 */
export function validatePassport(passport) {
  if (!passport) return false
  
  // Convertir a mayúsculas
  passport = passport.toUpperCase().trim()
  
  // Formato genérico: 6-12 caracteres alfanuméricos
  if (!/^[A-Z0-9]{6,12}$/.test(passport)) return false
  
  // Pasaportes válidos (no se puede validar algoritmo, solo formato)
  return true
}

/**
 * Validar tarjeta de identidad UE
 */
export function validateIDCardEU(idCard, country) {
  if (!idCard) return false
  
  idCard = idCard.toUpperCase().trim()
  
  // Validaciones específicas por país
  switch (country) {
    case 'FR':
      // Francia: 12 dígitos
      return /^[0-9]{12}$/.test(idCard)
    case 'DE':
      // Alemania: letra + 9 dígitos
      return /^[A-Z][0-9]{9}$/.test(idCard)
    case 'IT':
      // Italia: 2 letras + 5 dígitos + 2 letras
      return /^[A-Z]{2}[0-9]{5}[A-Z]{2}$/.test(idCard)
    default:
      // Formato genérico para otros países
      return /^[A-Z0-9]{6,15}$/.test(idCard)
  }
}

/**
 * Validar permiso de residencia
 */
export function validateResidencePermit(permit) {
  if (!permit) return false
  
  permit = permit.toUpperCase().trim()
  
  // Formato genérico: 6-15 caracteres alfanuméricos
  return /^[A-Z0-9]{6,15}$/.test(permit)
}

/**
 * Auto-detectar y validar DNI o NIE español
 */
export function validateSpanishDocument(value) {
  if (!value || value.length !== 9) return false
  
  const firstChar = value.charAt(0).toUpperCase()
  
  // Si empieza con X, Y, Z → es NIE
  if (/^[XYZ]/.test(firstChar)) {
    return validateNIEFromModule(value)
  }
  
  // Si empieza con dígito → es DNI
  if (/^[0-9]/.test(firstChar)) {
    return validateDNIFromModule(value)
  }
  
  return false
}

/**
 * Obtener documentos disponibles para un país
 */
export function getAvailableDocuments(countryCode) {
  const documentTypes = COUNTRY_DOCUMENTS[countryCode] || COUNTRY_DOCUMENTS.OTHER
  return documentTypes.map(type => ({
    value: type,
    ...DOCUMENT_CONFIG[type]
  }))
}

/**
 * Validar documento según su tipo
 */
export function validateDocument(documentType, documentNumber, country) {
  const config = DOCUMENT_CONFIG[documentType]
  if (!config) return false
  
  // Verificar formato básico
  if (!config.format.test(documentNumber)) return false
  
  // Aplicar validador específico
  const validatorName = config.validator
  
  switch (validatorName) {
    case 'validateDNI':
      // Usar el validador de DNI existente - se importa dinámicamente para evitar dependencias circulares
      return validateDNIFromModule(documentNumber)
    case 'validateNIE':
      return validateNIEFromModule(documentNumber)
    case 'validatePassport':
      return validatePassport(documentNumber)
    case 'validateIDCardEU':
      return validateIDCardEU(documentNumber, country)
    case 'validateResidencePermit':
      return validateResidencePermit(documentNumber)
    default:
      return false
  }
}

/**
 * Validar DNI español (copiar lógica de dniValidator.js para evitar imports)
 */
function validateDNIFromModule(dni) {
  if (!dni || dni.length !== 9) return false
  
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  const number = parseInt(dni.substring(0, 8), 10)
  const letter = dni.substring(8, 9).toUpperCase()
  
  if (isNaN(number)) return false
  
  const calculatedLetter = dniLetters.charAt(number % 23)
  return letter === calculatedLetter
}

/**
 * Validar NIE español (copiar lógica de dniValidator.js para evitar imports)
 */
function validateNIEFromModule(nie) {
  if (!nie || nie.length !== 9) return false
  
  const nieLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  const firstLetter = nie.substring(0, 1).toUpperCase()
  const number = nie.substring(1, 8)
  const controlLetter = nie.substring(8, 9).toUpperCase()
  
  if (!/^[XYZ]$/.test(firstLetter)) return false
  if (!/^[0-9]{7}$/.test(number)) return false
  
  let nieNumber = number
  if (firstLetter === 'X') nieNumber = '0' + number
  else if (firstLetter === 'Y') nieNumber = '1' + number
  else if (firstLetter === 'Z') nieNumber = '2' + number
  
  const calculatedLetter = nieLetters.charAt(parseInt(nieNumber, 10) % 23)
  return controlLetter === calculatedLetter
}

/**
 * Obtener países agrupados por región
 */
export function getCountriesByRegion() {
  const grouped = {}
  COUNTRIES.forEach(country => {
    if (!grouped[country.region]) {
      grouped[country.region] = []
    }
    grouped[country.region].push(country)
  })
  return grouped
}
